var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.edit)?_c('v-select',{attrs:{"clearable":"","options":_vm.gridOptions,"reduce":(t) => t.id},on:{"input":_vm.onInput},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}):_c('span',[(_vm.selectedLabel)?_c('span',[_vm._v(_vm._s(_vm.selectedLabel))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }